import {
  AUTH_FETCH_SUCCESS,
  AUTH_SIGNIN_SUCCESS,
  AUTH_SIGNOUT_SUCCESS,
  AUTH_PROFILE_FETCH_SUCCESS,
  AUTH_OPEN_POPUP,
  AUTH_CLOSE_POPUP,
  SIGNIN_OPEN_CONSENT,
  SIGNIN_CLOSE_CONSENT,
  SIGNIN_OPEN_CHANGE_DEFAULT_PASSWORD,
  SIGNIN_CLOSE_CHANGE_DEFAULT_PASSWORD ,
  POPUP_OPEN_TIER_SHOW,
  POPUP_CLOSE_TIER_SHOW,
  PDPA_REQUEST_SUCCESS
} from "../actions/types";

const RGB_HEX = /^#?(?:([\da-f]{3})[\da-f]?|([\da-f]{6})(?:[\da-f]{2})?)$/i;
const hex2RGB = (str, a) => {
  const [ , short, long ] = String(str).match(RGB_HEX) || [];

  if (long) {
    const value = Number.parseInt(long, 16);
    return 'rgb(' + String(value >> 16) + ', ' + String(value >> 8 & 0xFF) + ', ' + String( value & 0xFF)+ ', ' + a +  ')';
  
  } 
};

let authMember = {};
try {
  localStorage.setItem("demo", "demo");
  localStorage.getItem("demo");
  let localStorageMember = localStorage.getItem("member");
  authMember = JSON.parse(localStorageMember);
} catch (err) {
  alert("Please allow cookie to use this website");
}
const INIT_STATE = {
  auth: {},
  auths: {},
  authMember: authMember,
  profile: null,
  displayPopupRequestAuth: false,
  displayConsent: false,
  displayChangeDefaultPassword : false ,
  displayTierShow : false,
  authData : "",
  pdpa_reqest: false
};

export default (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case AUTH_FETCH_SUCCESS: {
      return {
        ...state,
        auth: {},
        auths: action.payload,
      };
    }
    case AUTH_SIGNIN_SUCCESS: {
      return {
        ...state,
        authMember: action.payload,
        profile: action.payload.member,
      };
    }
    case AUTH_PROFILE_FETCH_SUCCESS: {
      return {
        ...state,
        profile: action.payload,
        authMember: {
          ...state.authMember,
          success: true ,
          member: action.payload,
        },
      };
    }
    case AUTH_SIGNOUT_SUCCESS: {
      // window.location.reload()  //TODO:REVIEW
      // REMOVE MEMBER LEVEL THEME COLOR 
      let color = {primary_color: "#0079C0", secondary_color: "#0AA3E5"};
      
      // document.body.style.setProperty('--default',color.primary_color);
      // document.body.style.setProperty('--g1',  hex2RGB(color.primary_color , 0.5) );
      // document.body.style.setProperty('--g2',  hex2RGB(color.primary_color , 0.5) );
      // document.body.style.setProperty('--secondary', color.secondary_color);
  
      return {
        ...state,
        authMember: null,
        initURL: "/",
        profile: null,
      };
    }
    case AUTH_CLOSE_POPUP:
      document.body.classList.remove("modal-open");
      return {
        ...state,
        displayPopupRequestAuth: false
      };
    case AUTH_OPEN_POPUP:
      document.body.classList.add("modal-open");
      return {
        ...state,
        displayPopupRequestAuth: true,
        displayConsent : false
      };

    case SIGNIN_OPEN_CONSENT:
        document.body.classList.add("modal-open");
        return {
          ...state,
          displayPopupRequestAuth: false,
          displayConsent : true ,
          displayTierShow : false ,
          authMember : action.payload
        };


    case SIGNIN_CLOSE_CONSENT:
          document.body.classList.remove("modal-open");
          return {
            ...state,
            displayConsent : false
          };
  
    case SIGNIN_OPEN_CHANGE_DEFAULT_PASSWORD:
            document.body.classList.add("modal-open");
            return {
              ...state,
              displayConsent : false ,
              displayTierShow : false ,
              displayChangeDefaultPassword : true
            };

     case SIGNIN_CLOSE_CHANGE_DEFAULT_PASSWORD:
            document.body.classList.remove("modal-open");
            return {
              ...state,
              displayConsent : false ,
              displayChangeDefaultPassword : false
            };

     case POPUP_OPEN_TIER_SHOW:
              document.body.classList.add("modal-open");
              return {
                ...state,
                displayConsent : false ,
                displayChangeDefaultPassword : false ,
                displayTierShow : true 
              };

    case   POPUP_CLOSE_TIER_SHOW:
           document.body.classList.remove("modal-open");
           return {
                  ...state, 
                  displayTierShow : false 
                };
    case PDPA_REQUEST_SUCCESS: 
          return {
            ...state, 
            pdpa_reqest : true
          };
    default:
      return state;
  }
};
